// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"styles_fieldWrapper__0wLJm","formControl":"styles_formControl__rFaiQ","redStar":"styles_redStar__6kao6"};